import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isFirst: false,
    shareConfig: {},
    activitySetting: {},
    majorList: [],
    commonConfig: {}
  },
  mutations: {
    setShareConfig(state, obj) {
      // console.log(obj)
      state.shareConfig = obj
    },
    setActivitySetting(state, obj) {
      // console.log(obj)
      state.activitySetting = obj
    },
    setMajorList(state, data) {
      state.majorList = data
    },
    setCommonConfig(state, data) {
      state.commonConfig = data
    }
  },
  actions: {
  },
  modules: {
  }
})
